import script from "./FeedBackFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedBackFormPage.vue?vue&type=script&setup=true&lang=js"

import "./FeedBackFormPage.vue?vue&type=style&index=0&id=0564258a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0564258a"]])

export default __exports__